import { render, staticRenderFns } from "./dynamic-message.vue?vue&type=template&id=634c22dd&scoped=true&"
import script from "./dynamic-message.vue?vue&type=script&lang=js&"
export * from "./dynamic-message.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-message.vue?vue&type=style&index=0&id=634c22dd&prod&lang=scss&scoped=true&"
import style1 from "./dynamic-message.vue?vue&type=style&index=1&id=634c22dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c22dd",
  null
  
)

export default component.exports